var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 40,
    viewBox: "0 0 170 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1613_545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1172 30.9997L21.3796 17.0786L28.1567 17.0786L19.0325 30.9997H12.1172Z",
    fill: "#B3FF01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 21.9211L19.2604 8H26.0375L16.9133 21.9211H9.99805Z",
    fill: "#B3FF01"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9269 14.5949C39.9269 13.1811 40.7925 12.5751 42.8122 12.5751C45.0339 12.5751 45.9861 13.3542 45.9861 15.1719H51.1797C51.1797 10.7285 48.6694 8.82422 42.8122 8.82422C36.955 8.82422 34.4448 10.8151 34.4448 15.4605C34.4448 22.6738 45.9861 20.3655 45.9861 24.405C45.9861 25.8188 45.0339 26.4247 42.8122 26.4247C40.3886 26.4247 39.3498 25.6457 39.3498 23.8279H34.1562C34.1562 28.2713 36.753 30.1756 42.8122 30.1756C48.8714 30.1756 51.4682 28.1847 51.4682 23.5394C51.4682 15.749 39.9269 17.7687 39.9269 14.5949Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2076 25.2706H61.1287V9.40128H55.358V29.5986H72.2076V25.2706Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1515 8.82422C76.6785 8.82422 73.4758 12.0269 73.4758 19.4999C73.4758 26.9729 76.6785 30.1756 84.1515 30.1756C91.6245 30.1756 94.8272 26.9729 94.8272 19.4999C94.8272 12.0269 91.6245 8.82422 84.1515 8.82422ZM84.1515 25.8476C80.92 25.8476 79.535 23.9433 79.535 19.4999C79.535 15.0565 80.92 13.1522 84.1515 13.1522C87.3831 13.1522 88.7681 15.0565 88.7681 19.4999C88.7681 23.9433 87.3831 25.8476 84.1515 25.8476Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.229 21.5196H112.845C112.845 24.5492 111.46 25.8476 108.229 25.8476C104.997 25.8476 103.612 23.9433 103.612 19.4999C103.612 15.0565 104.997 13.1522 108.229 13.1522C110.796 13.1522 112.095 13.9312 112.556 15.749H118.039C117.058 10.9017 114.115 8.82422 108.229 8.82422C100.756 8.82422 97.5528 12.0269 97.5528 19.4999C97.5528 26.9729 100.756 30.1756 108.229 30.1756C115.298 30.1756 118.327 26.9729 118.327 19.4999V17.7687H108.229V21.5196Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.932 22.0967C120.932 27.752 123.615 30.1756 129.876 30.1756C136.137 30.1756 138.821 27.752 138.821 22.0967V9.40128H133.05V22.0967C133.05 24.7224 132.098 25.8476 129.876 25.8476C127.655 25.8476 126.702 24.7224 126.702 22.0967V9.40128H120.932V22.0967Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.89 16.0375C159.89 12.5751 157.582 9.40128 151.812 9.40128H142.579V29.5986H148.349V22.6738H151.812C157.582 22.6738 159.89 19.4999 159.89 16.0375ZM154.12 16.0375C154.12 17.4802 153.254 18.6343 151.523 18.6343H148.349V13.4407H151.523C153.254 13.4407 154.12 14.5949 154.12 16.0375Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1613_545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1579,
    height: 23,
    fill: "white",
    transform: "translate(10 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.22a81f050eaa215fcdf2b5be4097ecb5.svg";
export { ForwardRef as ReactComponent };